import { ReportResponse } from "../models/ReportResponse";

export const REMOVE_BEACON = "REMOVE BEACON";
export const GET_USER_INFO = "GET_USER_INFO";
export const BAN_USER = "BAN_USER";
export const GET_QUEUES = "GET_QUEUES";
export const GET_REPORT_HISTORY = "GET_REPORT_HISTORY";
export const DISMISS_REPORT = "DISMISS_REPORT";
export const SET_REPORT_VIEW_TYPE = "SET_REPORT_VIEW_TYPE";

export interface RemoveBeacon {
  type: typeof REMOVE_BEACON;
  payload: undefined;
}

export interface GetUserInfo {
  type: typeof GET_USER_INFO;
  payload: any; // fix typing
}

export interface BanUser {
  type: typeof BAN_USER;
  payload: any; // fix typing
}

export interface GetQueues {
  type: typeof GET_QUEUES;
  payload: ReportResponse | undefined;
}

export interface GetReportHistory {
  type: typeof GET_REPORT_HISTORY;
  payload: ReportResponse | undefined;
}

export interface DismissReport {
  type: typeof DISMISS_REPORT;
  payload: string;
}

export interface SetReportViewType {
  type: typeof SET_REPORT_VIEW_TYPE;
  payload: string;
}

export type ModerationActions =
  | RemoveBeacon
  | GetUserInfo
  | BanUser
  | GetQueues
  | GetReportHistory
  | DismissReport
  | SetReportViewType;
